import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconCardEcard = function IconCardEcard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 48"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    d: "m46.545 3.39-19.697 7.777 10.557 4.516a1.586 1.586 0 0 0 1.974-.621z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFA6B6",
    d: "M46.545 3.39 39.38 15.061a1.59 1.59 0 0 1-1.974.62l-10.557-4.515v18.666l19.303-15.166.075-2.139.075-2.139z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    fillRule: "evenodd",
    d: "M46.772 3.07a.387.387 0 0 1 .167.332l-.394 11.278a.39.39 0 0 1-.148.29L27.094 30.138a.4.4 0 0 1-.417.046.39.39 0 0 1-.223-.35V11.167c0-.16.098-.302.248-.361L46.4 3.028a.4.4 0 0 1 .373.043m-19.53 8.689 10.006 4.28a1.98 1.98 0 0 0 2.468-.776L46.1 4.865l-.336 9.609-18.522 14.553zm18.356-7.577L27.873 11.18l9.689 4.145a1.19 1.19 0 0 0 1.48-.466z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.848 17 4.394 23.611l13.788 5.056 8.666-5.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M26.848 29.833v-6.416l-8.666 5.25 1.575 15.944 4.728-12.833z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24.485 31.778 19.757 44.61c.316 0 6.172-6.222 9.061-9.333zm0 0 14.182 11.277L55.606 7.278zm21.741-19.25-.075 2.139 9.455-7.39z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m55.606 7.278-9.305 3.11-.075 2.14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00204D",
    fillRule: "evenodd",
    d: "M55.9 7.019c.105.116.13.283.063.424L39.023 43.22a.398.398 0 0 1-.604.138l-9.531-7.58a541 541 0 0 1-5.28 5.6c-.932.973-1.787 1.851-2.43 2.487-.32.317-.59.578-.794.76q-.151.137-.264.224a1 1 0 0 1-.117.08 1 1 0 0 1-.08.039.5.5 0 0 1-.165.032.39.39 0 0 1-.392-.351l-1.552-15.702-13.557-4.971A.39.39 0 0 1 4 23.599a.39.39 0 0 1 .281-.36l22.455-6.611a.4.4 0 0 1 .348.06c.1.074.158.19.158.312v12.027l18.522-14.553.143-4.098a.39.39 0 0 1 .268-.355L55.48 6.91a.4.4 0 0 1 .42.109M26.455 29.65v-5.54l-7.857 4.76 1.383 13.996 4.134-11.222a.4.4 0 0 1 .118-.166zm-5.782 13.613c.629-.624 1.457-1.475 2.364-2.42a540 540 0 0 0 5.21-5.526l-3.582-2.892zm4.442-11.485 13.408 10.663L54.537 8.617zm26.24-21.674-4.743 2.654-.037 1.081zm-4.71 1.742L51.8 8.961l-5.116 1.71zm-28.506 16.39 8.316-5.038v-5.677l-20.82 6.13z",
    clipRule: "evenodd"
  }));
};